import { sanitize } from '../utils';

const create = ({ listName, listId, items }) => {
    if (!items?.length) return;
    window.dataLayer = window?.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(
        sanitize({
            event: 'add_to_cart',
            ecommerce: {
                items: items?.map((item, idx) => ({
                    item_name: item?.title,
                    item_id: item?.sku,
                    price: item?.price,
                    item_brand: item?.brand,
                    item_category: item?.categories?.[0],
                    item_category2: item?.categories?.[1],
                    item_category3: item?.categories?.[2],
                    item_category5: item?.isClearance,
                    item_category6: item?.isNew,
                    item_list_name: listName || '',
                    item_list_id: listId || '',
                    index: idx + 1,
                    quantity: +item?.quantity,
                }),
            )},
        }),
    );
};

export default create;